export const REFRESH_VIEW = 'REFRESH_VIEW';

//************ refreshVersion ************//
export const refreshView = () => ({
  type: REFRESH_VIEW,
});